module.exports = __webpack_public_path__ + "img/satrexLogo.fe51fbd7.png";